<template>
<div v-if="botCount > 0 || trackCount > 0" class="pw-box" role="alert">
<div v-if="botCount > 0" class="pw-box__row">
<i class="fas fa-exclamation-triangle pw-box__icon" aria-hidden="true"></i>
<div>
<div class="pw-box__title">บอทไม่ตอบแชทในเพจ <b>{{ botNames }}</b></div>
<div class="pw-box__line">เชื่อมใหม่ก่อนส่งออเดอร์: <a :href="webUrl" @click="openLink" target="_blank" rel="noopener">เชื่อมเพจใหม่ <i class="fal fa-external-link" aria-hidden="true"></i></a></div>
</div>
</div>
<div v-if="botCount > 0 && trackCount > 0" class="pw-box__divider" role="presentation"></div>
<div v-if="trackCount > 0" class="pw-box__row">
<i class="fas fa-exclamation-triangle pw-box__icon" aria-hidden="true"></i>
<div>
<div class="pw-box__title">ลูกค้าไม่ได้รับเลขแทร็คทาง Messenger จากเพจ <b>{{ trackNames }}</b> <button type="button" class="pw-box__link" :disabled="connecting" @click="connect">เชื่อมเพจ</button></div>
</div>
</div>
</div>
</template>
<script>
import { mapGetters } from "vuex";
import { BOT_WEB_URL, openBotLink } from "@/helpers/botLink";
import { connectMessengerPage } from "@/helpers/connectMessengerPage";
export default {
name: "PageWarningsOrderBox",
data() {
return { webUrl: BOT_WEB_URL, connecting: false };
},
methods: {
openLink(e) {
openBotLink(e, this.$store);
},
connect() {
connectMessengerPage(this);
}
},
computed: {
...mapGetters("botPages", { botCount: "count", botNames: "names" }),
...mapGetters("trackingPages", { trackCount: "count", trackNames: "names" })
}
};
</script>
<style scoped>
.pw-box {
max-width: 640px; margin: 0 auto;
border: 1px solid #c62828; background: #fde3e3; color: #803c3c;
border-radius: .3rem; padding: .75rem 1rem; overflow-wrap: anywhere;
}
.pw-box__row { display: flex; align-items: flex-start; gap: .75rem; }
.pw-box__divider { height: 1px; background: #c62828; opacity: .35; margin: .6rem 0; }
.pw-box__icon { color: #c62828; font-size: 24px; margin-top: .1rem; }
.pw-box__title { font-weight: 700; font-size: 16px; }
.pw-box__line { font-size: 14px; }
.pw-box__line a, .pw-box__link {
color: #c62828; font-weight: 700; text-decoration: underline;
display: inline-block; padding: .5rem .25rem; min-height: 44px; line-height: 28px; box-sizing: border-box;
}
.pw-box__link { background: none; border: 0; cursor: pointer; font-size: inherit; }
.pw-box__link:disabled { opacity: .6; cursor: default; }
.pw-box__line a .fa-external-link { font-size: 12px; margin-left: .15rem; }
</style>
<style>
body.--dark .pw-box { background: #5a3a3a; border-color: #6b4747; color: #ffc9c9; }
body.--dark .pw-box .pw-box__icon,
body.--dark .pw-box .pw-box__line a,
body.--dark .pw-box .pw-box__link { color: #ff9d9d; }
body.--dark .pw-box .pw-box__divider { background: #ff9d9d; }
</style>

